import ViolationDetailTabs from './ViolationDetailTabs.container';
export default ViolationDetailTabs;
